import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import useAuthStore from "store/authStore";
import Cookies from "js-cookie";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import LoginUi from "./LoginUi/LoginUi";
import { BASE_URL } from "service";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);

  const [loading, setLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Sign In");

  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  const handleLogin = async () => {
    const processedEmail = email.trim().toLowerCase(); // 💡 Trim + lowercase

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/api/users/login`, {
        email: processedEmail,
        password,
      });

      const { accessToken } = response.data;

      Cookies.set("accessToken", accessToken, {
        expires: 7,
        secure: true,
        sameSite: "Strict",
      });

      setAuth({ email: processedEmail, accessToken });

      console.log("Login successful:", response.data);

      setButtonText("Login Successful");

      setTimeout(() => {
        setSuccessSB(true);
        setLoading(false);
      }, 500);

      // Generate referral code
      const referralResponse = await axios.post(
        `${BASE_URL}/api/referral/generate/?email=${processedEmail}`
      );

      console.log("Referral Code Generated:", referralResponse.data);

      if (referralResponse.data?.referral?.referral_code) {
        const upperCaseCode = referralResponse.data.referral.referral_code.toUpperCase();
        localStorage.setItem("referral_code", upperCaseCode);
      }

      setTimeout(() => {
        navigate("/dashboard");
      }, 3000);
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      setErrorSB(true);
      setLoading(false);
    }
  };

  return (
    <>
      <LoginUi
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        rememberMe={rememberMe}
        setRememberMe={setRememberMe}
        onLogin={handleLogin}
        loading={loading}
        buttonText={buttonText}
      />

      {/* Success Snackbar */}
      <Snackbar
        open={successSB}
        autoHideDuration={3000}
        onClose={() => setSuccessSB(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={() => setSuccessSB(false)} severity="success" sx={{ width: "100%" }}>
          Login Successful! Redirecting to dashboard...
        </Alert>
      </Snackbar>

      {/* Error Snackbar */}
      <Snackbar
        open={errorSB}
        autoHideDuration={3000}
        onClose={() => setErrorSB(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={() => setErrorSB(false)} severity="error" sx={{ width: "100%" }}>
          Login Failed! Please check your credentials.
        </Alert>
      </Snackbar>
    </>
  );
};

export default Login;
